export default function Cta() {
  return (
    <section id="cta" className="bg-background-50 border-t border-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="relative overflow-hidden rounded-lg bg-accent-500 text-background-50">
          <div className="absolute inset-0 bg-gradient-to-r from-accent-600/40 via-transparent to-accent-300/30" />
          <div className="relative px-6 py-10 md:px-10 md:py-14 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
            <div className="max-w-2xl">
              <p className="flex items-center gap-2 text-sm font-medium text-background-50/80">
                <i className="ri-chat-follow-up-line" />
                你有线索吗？
              </p>
              <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold leading-tight">
                报一段没人提过的全网黑料历史遗留
              </h2>
              <p className="mt-3 text-sm md:text-base leading-relaxed text-background-50/90">
                如果你手上有早年黑历史、失效链接或一段快被遗忘的旧账来源，欢迎把链接与时间线索整理后发给我们。核实与归档过程会保持克制，不放大情绪。
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 shrink-0 w-full lg:w-auto">
              <a
                href="#top"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-background-50 px-5 py-3 text-sm font-bold text-accent-800 hover:bg-background-100 whitespace-nowrap"
              >
                <i className="ri-send-plane-line" />
                提交线索入口
              </a>
              <a
                href="#faq"
                className="inline-flex items-center justify-center gap-2 rounded-md border border-background-50/40 px-5 py-3 text-sm font-semibold text-background-50 hover:bg-background-50/10 whitespace-nowrap"
              >
                先看整理须知
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}